<template>
  <div class="zujian">
    <el-upload
      action=""
      :file-list="listImg"
      ref="upload"
      :auto-upload=false
      :on-change="imgPreview"
      list-type="picture-card"
      accept="image/*"
      :limit="1"
      :on-preview="handlePreview"
      :on-remove="handleRemove" :class="[isAddImg?'hidden':'']
      ">
    </el-upload>
    <image-viewer v-if="imgViewerVisible" :urlList="previewSrcList" :on-close="onClose" :z-index="2100" />
  </div>
</template>

<script>
import ImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  name: 'uploadImg',
  components: {
    ImageViewer
  },
  props: ['img'],
  data () {
    return {
      listImg: this.img,
      isAddImg: false,
      previewSrcList: [],
      imgViewerVisible: false
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.img.length > 0) {
      this.isAddImg = true
    }
  },
  methods: {
    handleRemove (file, fileList) {
      console.log(fileList)
      if (fileList.length < 1) {
        this.isAddImg = false
      }
      this.$emit('remove', fileList)
    },

    imgPreview (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length < 1) {
          this.isAddImg = false
        } else {
          this.isAddImg = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
      this.$emit('change', fileList)
    },
    handlePreview (file) {
      // 把用户点击的那张图片放到第一个位置
      this.previewSrcList = this.listImg.filter(e => e.url !== file.url).map(e => e.url)
      this.previewSrcList.unshift(file.url)
      // 设置 图片查看器 进行显示
      this.imgViewerVisible = true
    },
    onClose () {
      this.imgViewerVisible = false
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
.imgDialog /deep/.el-dialog__body{
  text-align: center;
}
</style>
